const monthsInGenitive = [
  'января',
  'февраля',
  'марта',
  'апреля',
  'мая',
  'июня',
  'июля',
  'августа',
  'сентября',
  'октября',
  'ноября',
  'декабря',
];

export const formatedBookingPanelDateForReservation = (dateString: string) => {
  const date = new Date(dateString).toLocaleDateString('en-CA');
  return date;
};

export const formatedBookingDays = (
  startdate: string,
  enddate: string,
  reserv?: boolean,
  currentBooking?: boolean,
) => {
  const dates = (date: string) =>
    new Date(date).toLocaleDateString('ru-RU', {
      day: 'numeric',
      month: 'long',
    });
  const startDateObj = new Date(startdate);
  const endDateObj = new Date(enddate);
  const startMonthIndex = startDateObj.getMonth();
  const endMonthIndex = endDateObj.getMonth();

  const startMonth = monthsInGenitive[startMonthIndex];
  const endMonth = monthsInGenitive[endMonthIndex];

  if (!reserv && !currentBooking) {
    const result =
      startMonth === endMonth
        ? `Вы бронируете с ${startDateObj.getDate()} по ${endDateObj.getDate()} ${startMonth} ${startDateObj.getFullYear()} г.`
        : `Вы бронируете с ${dates(startdate)} по ${dates(enddate)}`;
    return result;
  }
  if (reserv) {
    const result =
      startMonth === endMonth
        ? `${startDateObj.getDate()}-${endDateObj.getDate()} ${startMonth}`
        : `${startDateObj.getDate()} ${startMonth} - ${endDateObj.getDate()} ${endMonth}`;

    return result;
  }
  if (currentBooking) {
    const result =
      startMonth === endMonth
        ? `${startDateObj.getDate()}-${endDateObj.getDate()} ${startMonth} ${endDateObj.getFullYear()} г.`
        : `${startDateObj.getDate()} ${startMonth} ${startDateObj.getFullYear()} г. - ${endDateObj.getDate()} ${endMonth} ${endDateObj.getFullYear()} г.`;

    return result;
  }
  return undefined;
};

export const formatedBookingDay = (dateString: string): string => {
  if (!dateString) return '';
  const date = new Date(dateString.replace(' ', 'T'));
  if (Number.isNaN(date.getTime())) {
    console.error('Invalid date string provided to formatEventDate');
    return '';
  }

  const timeFormatter = new Intl.DateTimeFormat('ru-RU', {
    hour: '2-digit',
    minute: '2-digit',
  });

  const dateFormatter = new Intl.DateTimeFormat('ru-RU', {
    day: 'numeric',
    month: 'long',
  });

  const time = timeFormatter.format(date);
  const datePart = dateFormatter.format(date);

  return `${time} ${datePart}`;
};

export const formatedCalendarDaysNoUTC = (date: string) => {
  const calendarDate = new Date(date).toISOString().split('T')[0];
  return calendarDate;
};

export const formatedCalendarDays = (dateInput: string | Date): string => {
  const d = dateInput instanceof Date ? dateInput : new Date(dateInput);
  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};
